// Central page version tracking for Boho Style Co.
// Increment versions when making significant content/functionality changes

export interface PageVersion {
  version: string;
  lastModified: string;
  description?: string;
}

export const PAGE_VERSIONS: Record<string, PageVersion> = {
  // Public Pages
  'home': {
    version: '2.1.0',
    lastModified: '2025-09-12',
    description: 'Removed misleading artisan content, upgraded featured products to use UnifiedProductCard system with lighter tab design'
  },
  'collections': {
    version: '1.3.1', 
    lastModified: '2025-01-27',
    description: 'Coral/sage gradient banner, display controls'
  },
  'products': {
    version: '2.0.0',
    lastModified: '2025-09-14',
    description: 'Hero auto-collapse system implementation - 14-second paragraph visibility with smooth rollup animation, focus detection, safe scroll management'
  },
  'about': {
    version: '1.1.0',
    lastModified: '2025-01-27',
    description: 'Brand narrative updates'
  },
  'contact': {
    version: '1.0.1',
    lastModified: '2025-01-27',
    description: 'Form validation improvements'
  },

  // Collection Pages
  'goddess-collection': {
    version: '1.1.0',
    lastModified: '2025-09-09',
    description: 'Fixed duplicate Chrome Hearts content placement'
  },
  'chrome-hearts-collection': {
    version: '1.0.0',
    lastModified: '2025-09-09',  
    description: 'Layout balancing complete, product thumbnails added, CTA section redesigned'
  },

  // Admin Pages  
  'admin-dashboard': {
    version: '2.2.0',
    lastModified: '2025-09-06',
    description: 'Removed performance optimization page, streamlined navigation'
  },
  'admin-suppliers': {
    version: '1.8.0', 
    lastModified: '2025-01-27',
    description: 'Enhanced security logging, data masking'
  },
  'admin-security': {
    version: '1.5.1',
    lastModified: '2025-09-11', 
    description: 'Fixed SecurityHeadersStatus non-2xx error, static display implementation'
  },
  'admin-backup': {
    version: '1.1.0',
    lastModified: '2025-01-27',
    description: 'Automated scheduling, MegaJS integration'
  },
  'admin-analytics': {
    version: '1.0.0',
    lastModified: '2025-01-31',
    description: 'First-party visitor analytics dashboard'
  },
  'admin-homepage-images': {
    version: '1.0.0',
    lastModified: '2025-01-31', 
    description: 'Homepage image rotation management system'
  },
  'admin-tech-inventory': {
    version: '2.6.0',
    lastModified: '2025-09-12',
    description: 'Product card system unification documented - UnifiedProductCard component with consistent lighter tab design across all pages'
  },
  'admin-master-todo': {
    version: '1.1.0',
    lastModified: '2025-09-11',
    description: 'Removed Tasha Apparel references (wholesale only now), updated edge function count'
  },
  'admin-config': {
    version: '1.0.0',
    lastModified: '2025-09-06',
    description: 'System configuration management with secure credential handling'
  },
  'knowledge-base': {
    version: '1.2.0',
    lastModified: '2025-09-11',
    description: 'Removed Tasha Apparel references - now wholesale only'
  }
};

export const getPageVersion = (pageKey: string): PageVersion => {
  return PAGE_VERSIONS[pageKey] || {
    version: '1.0.0',
    lastModified: '2025-01-27',
    description: 'Initial version'
  };
};

export const getAllVersions = (): Record<string, PageVersion> => {
  return PAGE_VERSIONS;
};